import { ReactNode } from 'react';

import { Column, Grid } from 'components/Blocks';

import { AttachedFile } from './File';

type FileRef = {
  url: string;
  name: string;
  type: string;
};

interface AttachedFilesProps {
  files?: FileRef[];

  label?: ReactNode;
}

export function AttachedFiles({ files, label }: AttachedFilesProps) {
  if (!files?.length) return null;

  const images = files.filter((f) => f.type.startsWith('image/'));

  const docs = files.filter((f) => !f.type.startsWith('image/'));

  const imageNode = images.length ? (
    <Grid cols={images.length} gap="2" className="w-fit">
      {images.map((file) => (
        <AttachedFile key={file.url} {...file} className="h-24 border" />
      ))}
    </Grid>
  ) : null;

  return (
    <Column gap="2" className="mt-1" fullWidth>
      {label}

      {imageNode}

      {docs.map((file) => (
        <AttachedFile key={file.url} {...file} />
      ))}
    </Column>
  );
}
